module.exports = __webpack_public_path__ + "static/media/about16.c46dc20f.webp";